/** Purpose: Formats bytes for display. Inputs: sizeBytes. Output: display string. */
export function formatFileSize(sizeBytes) {
  const size = Number(sizeBytes || 0);
  if (!Number.isFinite(size) || size <= 0) return '0 B';
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

/** Purpose: Formats raw record type value for display. Inputs: value, recordTypeOptions. Output: display label. */
export function formatRecordTypeLabel(value, recordTypeOptions) {
  const options = Array.isArray(recordTypeOptions) ? recordTypeOptions : [];
  const option = options.find((item) => item.value === value);
  if (option) return option.label;

  return String(value || '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/** Purpose: Formats purpose text for request-details display. Inputs: purpose, formatRecordType. Output: display text. */
export function formatPurposeForDisplay(purpose, formatRecordType) {
  const prefix = 'Release of medical records as requested:';
  if (!purpose) return 'Records requested: All';

  if (String(purpose).startsWith(prefix)) {
    const requested = String(purpose).slice(prefix.length).trim();
    const labels = requested
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean)
      .map((value) => (formatRecordType ? formatRecordType(value) : value));

    return `Records requested: ${labels.join(', ') || 'All'}`;
  }

  return purpose;
}

/** Purpose: Extracts date range from share/request payload. Inputs: permission, formatDate. Output: display date range. */
export function getRequestedDateRange(permission, formatDate) {
  if (!permission) return 'Not specified';

  if (permission.dateRangeStart || permission.dateRangeEnd) {
    const start = permission.dateRangeStart ? formatDate(permission.dateRangeStart) : 'Any';
    const end = permission.dateRangeEnd ? formatDate(permission.dateRangeEnd) : 'Present';
    return `${start} - ${end}`;
  }

  const text = String(permission.purposeDetails || permission.purpose || '');
  const match = text.match(/date range[:\s]+(.+)$/i);
  if (match?.[1]) return match[1].trim();

  return 'All';
}

